import React from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import Drc from "app/components/Drc";
import MainMenuItem from "app/components/MainMenuItem";

function DrcHomePage() {
  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        // pageTitle: "ホーム",
      }}
    >
      <Drc.MenuGrid>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          {<MainMenuItem.Drc.SalesOrderManagement.List />}
        </div>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          {<MainMenuItem.Drc.ExaminationResult.Create />}
        </div>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          {<MainMenuItem.Drc.ExaminationResult.List />}
        </div>
        <div className="flex items-center justify-center aspect-square w-full h-full p-[10%]">
          {<MainMenuItem.Drc.LabContact.Create />}
        </div>
      </Drc.MenuGrid>
    </DefaultLayout>
  );
}

export default DrcHomePage;
